export const storefrontClient = (query) => {
  const endpoint = `https://${window.BARREL.shop}/api/2024-04/graphql.json`
  const method = 'POST'
  const headers = {
    'Content-Type': 'application/json',
    'Accept': 'application/json', // eslint-disable-line
    'X-Shopify-Storefront-Access-Token': window.BARREL.storefrontAccessToken
  }

  return fetch(endpoint, {
    method: method,
    headers: headers,
    body: JSON.stringify({
      query: query
    })
  }).then(response => response.json())
}
